import React, { Fragment } from 'react'
import { Paper, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux'
import {
    actualizarFC_34PaginaActiva,
    ObtenerClientePorLogin34,
    obtenerContadorDeFechaFolio,
    registrarSolicitudFC_34Accion,
    actualizarFC_34Solicitud,
    resetDataFC_34,
    actualizarFC_34Estatus, agregarInstalaciones
} from '../../../redux/DucksBeneficiario/FC_34Ducks'
import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../redux/AppDucks'
import { useStateIfMounted } from 'use-state-if-mounted'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import SaveIcon from '@mui/icons-material/Save';
import IconButton from '@mui/material/IconButton';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import ToolBarPaginas from '../../App/ToolBarPaginas';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import estilos from './FormularioFC34BeneficiarioComponent.module.css';
const { useRef } = React;
import InfoBar from '../../App/InfoBar'
import BotonAtrasSiguienteComponent from '../../App/BotonAtrasSiguienteComponent';
import TerminosYCondicionesComponent from '../../App/TerminosYCondicionesComponent';
import { Formik } from 'formik'
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import { obtenerSolicitudesWithStatus } from '../../../redux/SolicitudesDucks';
import Tooltip from '@mui/material/Tooltip';
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import ModalEnviadoCorrectamente from '../../App/ModalEnviadoCorrectamente';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function FormularioFC34BeneficiarioComponent(props) {
    const dispatch = useDispatch()

    const usuario = useSelector(store => store.Usuario)
    let fc_34 = useSelector(store => store.FC_34Solicitud.fc_34)
    let modoEdicionBorrador = useSelector(store => store.FC_34Solicitud.modoEdicionBorrador)
    const modoCorreccion = useSelector(store => store.FC_34Solicitud.modoCorreccion)
    let data = useSelector(store => store.FC_34Solicitud.data)
    let fc_34Map = useSelector(store => store.FC_34Solicitud.fc_34Map)
    let dataCliente = useSelector(store => store.FC_34Solicitud.cliente)
    let dataLogin = useSelector(store => store.FC_34Solicitud.dataLogin)
    let instalacionesCliente = useSelector(store => store.FC_34Solicitud.instalacionesCliente)
    const idfc34_notificacionsuspencion = fc_34.idfc34_notificacionsuspencion
    const [envioCorrecto, setEnvioCorrecto] = React.useState(false)
    let instalaciones = useSelector(store => store.FC_34Solicitud.instalaciones)
    React.useEffect(() => {
        let data = dispatch(ObtenerClientePorLogin34({ idlogin: usuario.data.user[0].id }))
    }, [])

    let [terminosYCondiciones, setTerminosYCondiciones] = useStateIfMounted(false)
    const currentUser = useSelector(store => store.Usuario.data)

    React.useEffect(() => {
        if (props.history.location.state) {
            setTerminosYCondiciones(props.history.location.state.terminosYCondiciones)
        }
    }, [props.history.location.state])

    const [validacion, setvalidacion] = React.useState(false)
    const [folio, setFolio] = React.useState('')
    const [texto, settexto] = React.useState('')
    const [paginas, setPaginas] = useStateIfMounted([1, 2])
    const paginaActiva = useSelector(store => store.FC_34Solicitud.paginaActiva)
    const paginaSiguiente = async (valores) => {
        const result = await validation(valores)
        if (JSON.stringify(result) !== '{}') {
            settexto('')
            setvalidacion(true)
        } else {
            dispatch(actualizarFC_34PaginaActiva(paginaActiva + 1))
        }
    }
    const paginaAnterior = async () => {
        dispatch(actualizarFC_34PaginaActiva(paginaActiva - 1))
    }
    var fechaHoy = moment().format('YYYY-MM-DD');
    const idUsuario = usuario.data.user[0].id
    const idlogin = idUsuario
    const store = useSelector(store => store)

    const handleResetAllPropertys = () => {
        dispatch(resetDataFC_34())
        handleCloseModal()
        dispatch(resetDataFC_34())
    }

    React.useEffect(() => {
        if (!(JSON.stringify({}) === JSON.stringify(data))) {
            fc_34 = data
            dispatch(ObtenerClientePorLogin34({ idlogin: usuario.data.user[0].id }))
        }
    }, [fc_34, data])

    const [modoEdicionBorradorState, setModoEdicionBorradorState] = useStateIfMounted(modoEdicionBorrador)
    const [functionResetForm, setFunctionResetForm] = React.useState()
    const [functionSubmitForm, setFunctionSubmitForm] = React.useState()
    //Modal
    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const [dataModal, setDataModal] = React.useState('')

    const handleOpenModal = (data) => {
        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setOpenModal(true)
        setDataModal(data.data)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
        setDataModal('')
    }
    const modalComponent = () => {
        return (
            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        <center>{titleModal}</center>
                    </Typography>
                    <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                        <p className={`${estilos.bodyModal}`}>{bodyModal}</p> <center><strong>¿Desea continuar?</strong></center>
                    </Typography>
                    <br />
                    <div className='row'>
                        <button className='btn btn-success' onClick={() => {
                            switch (accion) {
                                case 'enviarSolicitudFC_34':
                                    activarBotonEnviarForm()
                                    functionSubmitForm.function()
                                    break;
                                case 'guardarBorrador':
                                    guardarBorrador(dataModal)
                                    break;
                                case 'actualizarBorrador':
                                    actualizarBorrador(dataModal)
                                    break;
                                case 'reiniciarFormato':
                                    handleResetAllPropertys()
                                    functionResetForm.function()
                                    break;
                                case 'enviarSolicitudBorradorFC_34':
                                    activarBotonEnviarBorrador()
                                    functionSubmitForm.function()
                                    break;
                                case 'enviarBorrador':
                                    enviarBorrador()
                                    break;
                                case 'enviarCorreccion':
                                    activarBotonEnviarCorreciones()
                                    functionSubmitForm.function()
                                    break;
                                default:
                                    break;
                            }
                        }
                        }>CONTINUAR</button>
                    </div>
                </Box>
            </Modal>
        )
    }
    let botonEnviarRegistro = false
    let botonEnviarBorrador = false
    const [botonEnviarCorrecciones, setBotonEnviarCorrecciones] = React.useState(false)
    const activarBotonEnviarCorreciones = () => {
        setBotonEnviarCorrecciones(true)
    }
    const activarBotonEnviarForm = () => {
        botonEnviarRegistro = true
    }
    const activarBotonEnviarBorrador = () => {
        botonEnviarBorrador = true
    }
    const botonEnviarSolicitudFC_34 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de enviar el formulario al personal de atención al cliente, 
            ya no podrá seguir corrigiendo esta solicitud.`,
            accion: 'enviarSolicitudFC_34'
        })
    }
    const botonGuardarComoBorrador = async (valores) => {
        if (modoEdicionBorrador) {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de actualizar este borrador de solicitud.`,
                accion: 'actualizarBorrador',
                data: valores
            })
        } else {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de guardar esta solicitud en su apartado de borradores.`,
                accion: 'guardarBorrador',
                data: valores
            })
        }
    }
    const botonEnviarSolicitudBorradorFC_34 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente se enviará la solicitud al personal de atención al cliente.`,
            accion: 'enviarSolicitudBorradorFC_34'
        })
    }
    const botonReiniciarFormato = () => {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de reiniciar el formato, esta acción eliminará toda la información
            y no se podrá revertir.`,
            accion: 'reiniciarFormato'
        })
    }
    const botonEnviarCorreccionesFC_34 = async () => {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de enviar las correcciones al personal de atención al cliente, 
            ya no podrá seguir corrigiendo esta solicitud.`,
            accion: 'enviarCorreccion'
        })
    }
    const botonRegistrarFC_34 = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let fechaCorte = new Date(valores.fechacortecosecha).toISOString()
        let fechaInicio = new Date(valores.fechainicioproduccion).toISOString()
        let fechaTermino = new Date(valores.fechaterminoproduccion).toISOString()
        let fechaMuestreo = new Date(valores.fechamuestreo).toISOString()
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio
        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))
        var añoFolio = moment().format('YY');
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 9999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio
        let cortar = valores.tipoinstalacion.split('/')
        let tipoinstalacion = cortar[1]
        const solicitud = {
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, nombrerazonsocial: dataCliente.nombrerazonsocial,
            tipoinstalacion: valores.tipoinstalacion, responsableinstalaciones: valores.responsableinstalaciones, correoelectronico: valores.correoelectronico,
            telefono: valores.telefono, domicilio: valores.domicilio, certificadonomproductor: valores.certificadonomproductor,
            servicioactividad: valores.servicioactividad, servicioinstalacion: valores.servicioinstalacion,
            certificadonomcomercializador: valores.certificadonomcomercializador, motivosuspencion: valores.motivosuspencion,
            fechacortecosecha: fechaCorte, fechainicioproduccion: fechaInicio, especiesagaveutilizado: valores.especiesagaveutilizado,
            fechaterminoproduccion: fechaTermino, numerolote: valores.numerolote, kgagave: valores.kgagave, fechamuestreo: fechaMuestreo,
            informacionadicional: valores.informacionadicional,
            idestatusdesolicitudes: 2, idlogin: idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, folio: consFolio,
        }

        const resultado = await dispatch(registrarSolicitudFC_34Accion(solicitud))
        await dispatch(actualizarLoadingApp_false())
        
        setFolio(consFolio)
        setEnvioCorrecto(true)
        if (resultado) {
            await dispatch(resetDataFC_34())
            functionResetForm.function()
            //await dispatch(obtenerSolicitudesWithStatus({ status: 2, idLogin: currentUser.user[0].id }))
            //props.history.push('/solicitudes')
        }
    }
    const guardarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio
        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))

        var añoFolio = moment().format('YY');
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 9999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio

        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let fechaCorte = new Date(valores.fechacortecosecha).toISOString()
        let fechaInicio = new Date(valores.fechainicioproduccion).toISOString()
        let fechaTermino = new Date(valores.fechaterminoproduccion).toISOString()
        let fechaMuestreo = new Date(valores.fechamuestreo).toISOString()
        let cortar = valores.tipoinstalacion.split('/')
        let tipoinstalacion = cortar[1]
        const solicitud = {
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, nombrerazonsocial: dataCliente.nombrerazonsocial,
            tipoinstalacion: valores.tipoinstalacion, responsableinstalaciones: valores.responsableinstalaciones, correoelectronico: valores.correoelectronico,
            telefono: valores.telefono, domicilio: valores.domicilio, certificadonomproductor: valores.certificadonomproductor,
            servicioactividad: valores.servicioactividad, servicioinstalacion: valores.servicioinstalacion,
            certificadonomcomercializador: valores.certificadonomcomercializador, motivosuspencion: valores.motivosuspencion,
            fechacortecosecha: fechaCorte, fechainicioproduccion: fechaInicio, especiesagaveutilizado: valores.especiesagaveutilizado,
            fechaterminoproduccion: fechaTermino, numerolote: valores.numerolote, kgagave: valores.kgagave, fechamuestreo: fechaMuestreo,
            informacionadicional: valores.informacionadicional,
            idestatusdesolicitudes: 1, idlogin: idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, folio: consFolio,
        }

        const resultado = await dispatch(registrarSolicitudFC_34Accion(solicitud))
        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_34())
            await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        } else {
        }
    }
    const actualizarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let fechaCorte = new Date(valores.fechacortecosecha).toISOString()
        let fechaInicio = new Date(valores.fechainicioproduccion).toISOString()
        let fechaTermino = new Date(valores.fechaterminoproduccion).toISOString()
        let fechaMuestreo = new Date(valores.fechamuestreo).toISOString()
        let cortar = valores.tipoinstalacion.split('/')
        let tipoinstalacion = cortar[1]
        const solicitud = {
            fechasolicitud: fechaSolicitud, idfc34_notificacionsuspencion: fc_34.idfc34_notificacionsuspencion,
            tipoinstalacion: valores.tipoinstalacion, responsableinstalaciones: valores.responsableinstalaciones, correoelectronico: valores.correoelectronico,
            telefono: valores.telefono, domicilio: valores.domicilio, certificadonomproductor: valores.certificadonomproductor,
            servicioactividad: valores.servicioactividad, servicioinstalacion: valores.servicioinstalacion,
            certificadonomcomercializador: valores.certificadonomcomercializador, motivosuspencion: valores.motivosuspencion,
            fechacortecosecha: fechaCorte, fechainicioproduccion: fechaInicio, especiesagaveutilizado: valores.especiesagaveutilizado,
            fechaterminoproduccion: fechaTermino, numerolote: valores.numerolote, kgagave: valores.kgagave, fechamuestreo: fechaMuestreo,
            informacionadicional: valores.informacionadicional,
            idestatusdesolicitudes: 1,
        }
        const resultado = await dispatch(actualizarFC_34Solicitud(solicitud))

        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_34())
            await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        } else {
        }
    }
    const enviarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let fechaCorte = new Date(valores.fechacortecosecha).toISOString()
        let fechaInicio = new Date(valores.fechainicioproduccion).toISOString()
        let fechaTermino = new Date(valores.fechaterminoproduccion).toISOString()
        let fechaMuestreo = new Date(valores.fechamuestreo).toISOString()
        let cortar = valores.tipoinstalacion.split('/')
        let tipoinstalacion = cortar[1]
        const solicitud = {
            fechasolicitud: fechaSolicitud, idfc34_notificacionsuspencion: data.idfc34_notificacionsuspencion,
            tipoinstalacion: valores.tipoinstalacion, responsableinstalaciones: valores.responsableinstalaciones, correoelectronico: valores.correoelectronico,
            telefono: valores.telefono, domicilio: valores.domicilio, certificadonomproductor: valores.certificadonomproductor,
            servicioactividad: valores.servicioactividad, servicioinstalacion: valores.servicioinstalacion,
            certificadonomcomercializador: valores.certificadonomcomercializador, motivosuspencion: valores.motivosuspencion,
            fechacortecosecha: fechaCorte, fechainicioproduccion: fechaInicio, especiesagaveutilizado: valores.especiesagaveutilizado,
            fechaterminoproduccion: fechaTermino, numerolote: valores.numerolote, kgagave: valores.kgagave, fechamuestreo: fechaMuestreo,
            informacionadicional: valores.informacionadicional,
            idestatusdesolicitudes: 2,
        }
        const resultado = await dispatch(actualizarFC_34Solicitud(solicitud))
        const idSolicitud = idfc34_notificacionsuspencion
        const estatusNuevo = 2
        const idCliente = dataCliente.idcliente//null //Se necesita obtener del cliente, a traves del login 
        const tablaFC_34 = 8
        const tabla = tablaFC_34
        await dispatch(actualizarFC_34Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
        ))
        await dispatch(resetDataFC_34())
        functionResetForm.function()
        await dispatch(actualizarLoadingApp_false())

        await dispatch(obtenerSolicitudesWithStatus({ status: 2, idLogin: currentUser.user[0].id }))
        props.history.push('/solicitudes')
    }
    const enviarCorreccion = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        let fechaSolicitud = new Date(fechaHoy)?.toISOString()
        let fechaCorte = ''
        if (valores.fechacortecosecha) fechaCorte = new Date(valores.fechacortecosecha).toISOString()
        let fechaInicio = ''
        if (valores.fechainicioproduccion) fechaInicio = new Date(valores.fechainicioproduccion).toISOString()
        let fechaTermino = ''
        if (valores.fechaterminoproduccion) fechaTermino = new Date(valores.fechaterminoproduccion).toISOString()
        let fechaMuestreo = ''
        if (valores.fechamuestreo) fechaMuestreo = new Date(valores.fechamuestreo).toISOString()

        const solicitud = {
            fechasolicitud: fechaSolicitud, idfc34_notificacionsuspencion: data.idfc34_notificacionsuspencion,
            tipoinstalacion: valores.tipoinstalacion, responsableinstalaciones: valores.responsableinstalaciones, correoelectronico: valores.correoelectronico,
            telefono: valores.telefono, domicilio: valores.domicilio, certificadonomproductor: valores.certificadonomproductor,
            servicioactividad: valores.servicioactividad, servicioinstalacion: valores.servicioinstalacion,
            certificadonomcomercializador: valores.certificadonomcomercializador, motivosuspencion: valores.motivosuspencion,
            fechacortecosecha: fechaCorte, fechainicioproduccion: fechaInicio, especiesagaveutilizado: valores.especiesagaveutilizado,
            fechaterminoproduccion: fechaTermino, numerolote: valores.numerolote, kgagave: valores.kgagave, fechamuestreo: fechaMuestreo,
            informacionadicional: valores.informacionadicional,
            idestatusdesolicitudes: 6,
        }
        const resultado = await dispatch(actualizarFC_34Solicitud(solicitud))
        const idSolicitud = data.idfc34_notificacionsuspencion
        const estatusNuevo = 6
        const idCliente = dataCliente.idcliente//null //Se necesita obtener del cliente, a traves del login 
        const tablaFC_34 = 8
        const tabla = tablaFC_34
        await dispatch(actualizarFC_34Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
        ))
        await dispatch(resetDataFC_34())
        handleResetAllPropertys()
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/solicitudes')
    }

    const setDatos = (datos) => {
        let dato = datos.split('/')
        let idanexocliente = dato[1]
        let tipoanexo = Number(dato[0])
        for (let dato in instalaciones) {
            if (instalaciones?.[dato]?.idanexocliente == idanexocliente) {
                const telefono = instalaciones[dato].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[0].telefono
                const correoelectronico = instalaciones[dato].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[0].correoelectronico
                const responsableinstalaciones = instalaciones[dato].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[0].nombreresponsable
                let numeroint = ''
                let numeroext = ''
                if (instalaciones[dato].informaciongeneralinstalacioncliente.numerointerior === null ||
                    instalaciones[dato].informaciongeneralinstalacioncliente.numerointerior === undefined ||
                    instalaciones[dato].informaciongeneralinstalacioncliente.numerointerior === '') numeroint = 's/n'
                else { numeroint = instalaciones[dato].informaciongeneralinstalacioncliente.numerointerior }
                if (instalaciones[dato].informaciongeneralinstalacioncliente.numeroexterior === null ||
                    instalaciones[dato].informaciongeneralinstalacioncliente.numeroexterior === undefined ||
                    instalaciones[dato].informaciongeneralinstalacioncliente.numeroexterior === '') numeroext = 's/n'
                else { numeroext = instalaciones[dato].informaciongeneralinstalacioncliente.numeroexterior }
                const domicilio = instalaciones[dato].informaciongeneralinstalacioncliente.calle + ',' +
                    numeroint + ',' + numeroext + ',' +
                    instalaciones[dato].informaciongeneralinstalacioncliente.colonia + ',' +
                    instalaciones[dato].informaciongeneralinstalacioncliente.localidad + ',' +
                    instalaciones[dato].informaciongeneralinstalacioncliente.municipio + ',' +
                    instalaciones[dato].informaciongeneralinstalacioncliente.estado + ',' +
                    instalaciones[dato].informaciongeneralinstalacioncliente.codigopostal
                return { responsableinstalaciones, telefono, correoelectronico, domicilio }
            }
        }
        return ''
    }
    const validation = async values => {
        let errores = {};
        const textoCheck = 'Debe de seleccionar al menos una opción'
        const texto = 'Campo Obligatorio'
        if (paginaActiva === 1) {
            if (!values.servicioinstalacion) { errores.servicioinstalacion = texto }
            if (!values.servicioactividad) { errores.servicioactividad = texto }
            if (!values.correoelectronico) { errores.correoelectronico = texto }
            if (!values.telefono) { errores.telefono = texto }
            if (!values.domicilio) { errores.domicilio = texto }
            if (values.servicioinstalacion == 'produccion') {
                let filtro = instalacionesCliente.filter(anexo => anexo.idtipoanexo == 1)
                await dispatch(agregarInstalaciones(filtro))
                if (values.servicioactividad == 'reactivacion') {
                    if (!values.fechacortecosecha) { errores.fechacortecosecha = texto }
                    if (!values.fechainicioproduccion) { errores.fechainicioproduccion = texto }
                    if (!values.especiesagaveutilizado) { errores.especiesagaveutilizado = texto }
                    if (!values.fechaterminoproduccion) { errores.fechaterminoproduccion = texto }
                    if (!values.numerolote) { errores.numerolote = texto }
                    if (!values.kgagave) { errores.kgagave = texto }
                    if (!values.fechamuestreo) { errores.fechamuestreo = texto }
                    if (!values.informacionadicional) { errores.informacionadicional = texto }
                }

            }
            if (values.servicioinstalacion == 'envasado') {
                let filtro = instalacionesCliente.filter(anexo => anexo.idtipoanexo == 2)
                await dispatch(agregarInstalaciones(filtro))
            }
            if (values.servicioinstalacion == 'almacen') {
                let filtro = instalacionesCliente.filter(anexo => anexo.idtipoanexo == 3)
                await dispatch(agregarInstalaciones(filtro))
            }
        }
        return errores;
    }
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    return (
        <Fragment>
            <Formik
                initialValues={
                    fc_34
                }
                validate={validation}
                onSubmit={(valores) => {
                    if (botonEnviarRegistro) {
                        botonRegistrarFC_34(valores)
                    }
                    if (botonEnviarBorrador) {
                        enviarBorrador(valores)
                    }
                    if (botonEnviarCorrecciones) {
                        enviarCorreccion(valores)
                    }
                }}>
                {({ values, handleChange, handleSubmit, handleBlur, errors, touched, resetForm, submitForm, setValues }) => (
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className='container2'>
                            {
                                <div className='row mt-3'>
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-12 marginsitoTop">
                                        <InfoBar nombreSolicitud={'Solicitud de suspensión y reactivación'} />
                                    </div>
                                    {
                                        !modoCorreccion &&
                                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center marginsitoTop">
                                            <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                                aria-label="Guardar cambios" aria-haspopup="true" onClick={() =>
                                                    botonGuardarComoBorrador(values)}
                                            >
                                                <SaveIcon />
                                                {
                                                    modoEdicionBorrador ? (
                                                        <div className="badge text-dark textoNormal textoModal">
                                                            Guardar cambios en borrador
                                                        </div>) : (
                                                        <div className="badge text-dark textoNormal textoModal">
                                                            Guardar como borrador
                                                        </div>
                                                    )
                                                }
                                            </IconButton>
                                        </div>
                                    }
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 text-center">
                                        <h1></h1>
                                    </div>
                                    {
                                        !modoCorreccion &&
                                        <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 text-center marginsitoTop">
                                            <Fragment>
                                                <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                                    aria-label="Reiniciar formato" aria-haspopup="true" color="error" onClick={() =>
                                                        botonReiniciarFormato()}
                                                >
                                                    <FormatClearIcon />
                                                    <div className="badge text-dark textoNormal textoModal">Reiniciar Formato </div>
                                                </IconButton>
                                            </Fragment>
                                        </div>
                                    }
                                </div>
                            }
                            {paginaActiva === 1 ?
                                <Fragment>
                                    <div className='row justify-content-start'>
                                        <div className='row'>
                                            <h4 className={`text-center ${estilos.labelNaranja} mb-3`}>SERVICIO SOLICITADO</h4>
                                        </div>
                                        <div className={`row  ${estilos.divSoloBorderNaranja}`}>

                                            <div className='col-xs-12 col-sm-12 col-md-6 col-xl-6 col-xxl-6'>
                                                <div className="form-floating mb-3">
                                                    <select
                                                        name="servicioinstalacion"
                                                        value={values.servicioinstalacion}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        className={`form-select ${fc_34Map.servicioinstalacioncheck !== undefined ? (
                                                            fc_34Map?.servicioinstalacioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`} >
                                                        <option value="0">Seleccione la instalación a notificar</option>
                                                        <option value="produccion" >PRODUCCIÓN</option>
                                                        <option value="envasado">ENVASADO</option>
                                                        <option value="almacen">ALMACÉN</option>

                                                    </select>
                                                    <label htmlFor='floatingInput'></label>
                                                    <span className='text-danger'>{fc_34Map?.servicioinstalacioncheck ? fc_34Map?.servicioinstalacion : ''}</span>
                                                    {touched.servicioinstalacion && errors.servicioinstalacion && <div className="text-danger">{errors.servicioinstalacion}</div>}
                                                </div>
                                            </div>
                                            <div className='col-xs-12 col-sm-12 col-md-6 col-xl-6 col-xxl-6'>
                                                <div className="form-floating mb-3">
                                                    <select
                                                        name="servicioactividad"
                                                        value={values.servicioactividad}
                                                        onChange={e => {
                                                            const { ...newValues } = values
                                                            newValues.servicioactividad = e.target.value
                                                            if (e.target.value == 'reactivacion' && values.servicioinstalacion == 'produccion') {
                                                                newValues.certificadonomproductor = true
                                                            }else{
                                                                newValues.certificadonomproductor = false
                                                            }
                                                            if (e.target.value == 'reactivacion' && values.servicioinstalacion == 'envasado') {
                                                                newValues.certificadonomcomercializador = true
                                                            }else{
                                                                newValues.certificadonomcomercializador = false
                                                            }
                                                            setValues(newValues)
                                                        }}
                                                        onBlur={handleBlur}
                                                        className={`form-select ${fc_34Map.servicioactividadcheck !== undefined ? (
                                                            fc_34Map?.servicioactividadcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} >
                                                        <option value="0">Seleccione la actividad a notificar</option>
                                                        <option value="suspension" >SUSPENSIÓN</option>
                                                        <option value="reactivacion">REACTIVACIÓN</option>
                                                    </select>
                                                    <label htmlFor='floatingInput'></label>
                                                    <span className='text-danger'>{fc_34Map?.servicioactividadcheck ? fc_34Map?.servicioactividad : ''}</span>
                                                    {touched.servicioactividad && errors.servicioactividad && <div className="text-danger">{errors.servicioactividad}</div>}
                                                </div>
                                            </div><br /><br />
                                            {(values.servicioactividad == 'reactivacion' && (values.servicioinstalacion == 'produccion' || values.servicioinstalacion == 'envasado')) &&
                                                <div className='col-md-6'>
                                                    <label className="ms-1"><small>Al notificar la reactivación, solicita automáticamente la actualización del:</small></label>
                                                </div>
                                            }
                                            {(values.servicioinstalacion == 'produccion' && values.servicioactividad == 'reactivacion') &&
                                                <div className='text-start col-md-6'>
                                                    <input className={`form-check-input ${fc_34Map.certificadonomproductorcheck !== undefined ? (
                                                        fc_34Map?.certificadonomproductorcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                        checked={values.certificadonomproductor} id='certificadonomproductor'
                                                        name="certificadonomproductor"
                                                        onBlur={handleBlur} />
                                                    <label className="form-check-label me-1" htmlFor="flexCheckChecked"
                                                        title='Solicito que durante la vigencia del Certificado NOM de productor 
                                                        se emita el Certificado NOM de mezcal a granel para todos los 
                                                        lotes de mezcal a granel después de constatar la conformidad 
                                                        con la NOM-070-SCFI-2016.'>
                                                        Certificado NOM de productor
                                                    </label>
                                                </div>
                                            }
                                            {(values.servicioinstalacion == 'envasado' && values.servicioactividad == 'reactivacion') &&
                                                <div className='text-start col-md-6'>
                                                    <input className={`form-check-input ${fc_34Map?.certificadonomcomercializadorcheck !== undefined ? (
                                                        fc_34Map?.certificadonomcomercializadorcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                        checked={values.certificadonomcomercializador} id='certificadonomcomercializador'
                                                        name="certificadonomcomercializador"
                                                        onBlur={handleBlur} />
                                                    <label className="form-check-label me-1" htmlFor="flexCheckChecked"
                                                        title='Solicito que durante la vigencia del Certificado NOM de Comercializador 
                                                        se emita el Certificado NOM de Venta Nacional de mezcal por cada lote envasado 
                                                        posterior a la constatación del cumplimiento con la NOM-070-SCFI-2016.'>
                                                        Certificado NOM de comercializador
                                                    </label>
                                                </div>
                                            }
                                            {values.servicioactividad == 'suspension' &&
                                                <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-floating'>
                                                    <textarea type="textarea" rows='3' className={`form-control ${fc_34Map.motivosuspencioncheck !== undefined ? (
                                                        fc_34Map?.motivosuspencioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                        id="" placeholder='Motivo de suspención'
                                                        name="motivosuspencion"
                                                        value={values.motivosuspencion}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                    <label htmlFor='floatingInput'>Motivo de la suspensión</label>
                                                    <span className='text-danger'>{fc_34Map?.motivosuspencioncheck ? fc_34Map?.motivosuspencion : ''}</span>
                                                    {touched.motivosuspencion && errors.motivosuspencion && <div className="text-danger">{errors.motivosuspencion}</div>}
                                                </div>
                                            }
                                            {((values.servicioinstalacion == 'almacen' || values.servicioinstalacion == 'envasado') && values.servicioactividad == 'reactivacion') &&
                                                <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2'>
                                                    <div className="form-floating mb-3">
                                                        <textarea type="textarea" rows='5' className={`form-control ${fc_34Map.informacionadicionalcheck !== undefined ? (
                                                            fc_34Map?.informacionadicionalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            id="" placeholder='Información adicional de la actividad'
                                                            name="informacionadicional"
                                                            value={values.informacionadicional}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        <label htmlFor='floatingInput'>Información adicional sobre la actividad</label>
                                                        <span className='text-danger'>{fc_34Map?.informacionadicionalcheck ? fc_34Map?.informacionadicional : ''}</span>
                                                        <span className='text-danger'>{values.servicioinstalacion == 'envasado' && values.servicioactividad == 'reactivacion' ? 'Para la reactivación del envasado es necesario solicitar el envasado de un lote a través de los formatos FC-33 Nacional y/o FC-09 Exportación' : ''}</span>
                                                        {touched.informacionadicional && errors.informacionadicional && <div className="text-danger">{errors.informacionadicional}</div>}
                                                    </div>
                                                </div>}
                                            {(values.servicioinstalacion == 'produccion' && values.servicioactividad == 'reactivacion') &&
                                                <Fragment>
                                                    <div className='row mt-3'>
                                                        <h5 className={`text-center`} ><b>REACTIVACIÓN DE LA PRODUCCIÓN</b></h5>
                                                    </div>
                                                    <div className='row justify-content-start mt-3'>
                                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                            <div className="form-floating mb-3">
                                                                <input type="date" className={`form-control ${fc_34Map.fechacortecosechacheck !== undefined ? (
                                                                    fc_34Map?.fechacortecosechacheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    id="" placeholder='Fecha de corte de cosecha' min={fechaHoy}
                                                                    name="fechacortecosecha"
                                                                    value={values.fechacortecosecha}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur} />
                                                                <label htmlFor='floatingInput'>Fecha de corte o cosecha</label>
                                                                <span className='text-danger'>{fc_34Map?.fechacortecosechacheck ? fc_34Map?.fechacortecosecha : ''}</span>
                                                                {touched.fechacortecosecha && errors.fechacortecosecha && <div className="text-danger">{errors.fechacortecosecha}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                            <div className="form-floating mb-3">
                                                                <input type="date" className={`form-control ${fc_34Map.fechainicioproduccioncheck !== undefined ? (
                                                                    fc_34Map?.fechainicioproduccioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    id="" placeholder='Fecha de inicio de producción' min={fechaHoy}
                                                                    name="fechainicioproduccion"
                                                                    value={values.fechainicioproduccion}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur} />
                                                                <label htmlFor='floatingInput'>Fecha de inicio de producción</label>
                                                                <span className='text-danger'>{fc_34Map?.fechainicioproduccioncheck ? fc_34Map?.fechainicioproduccion : ''}</span>
                                                                {touched.fechainicioproduccion && errors.fechainicioproduccion && <div className="text-danger">{errors.fechainicioproduccion}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                            <div className="form-floating mb-3">
                                                                <input type="text" className={`form-control ${fc_34Map.especiesagaveutilizadocheck !== undefined ? (
                                                                    fc_34Map?.especiesagaveutilizadocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    id="" placeholder='Especies de agave utilizado'
                                                                    name="especiesagaveutilizado"
                                                                    value={values.especiesagaveutilizado}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <label htmlFor='floatingInput'>Especies de agave utilizado</label>
                                                                <span className='text-danger'>{fc_34Map?.especiesagaveutilizadocheck ? fc_34Map?.especiesagaveutilizado : ''}</span>
                                                                {touched.especiesagaveutilizado && errors.especiesagaveutilizado && <div className="text-danger">{errors.especiesagaveutilizado}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                            <div className="form-floating mb-3">
                                                                <input type="date" className={`form-control ${fc_34Map.fechaterminoproduccioncheck !== undefined ? (
                                                                    fc_34Map?.fechaterminoproduccioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    id="" placeholder='Fecha de termino' min={fechaHoy}
                                                                    name="fechaterminoproduccion"
                                                                    value={values.fechaterminoproduccion}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur} />
                                                                <label htmlFor='floatingInput'>Fecha estimada de término de producción</label>
                                                                <span className='text-danger'>{fc_34Map?.fechaterminoproduccioncheck ? fc_34Map?.fechaterminoproduccion : ''}</span>
                                                                {touched.fechaterminoproduccion && errors.fechaterminoproduccion && <div className="text-danger">{errors.fechaterminoproduccion}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                            <div className="form-floating mb-3">
                                                                <input type="text" className={`form-control ${fc_34Map.numerolotecheck !== undefined ? (
                                                                    fc_34Map?.numerolotecheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    id="" placeholder='Número delote'
                                                                    name="numerolote"
                                                                    value={values.numerolote}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur} />
                                                                <label htmlFor='floatingInput'>Número de lote</label>
                                                                <span className='text-danger'>{fc_34Map?.numerolotecheck ? fc_34Map?.numerolote : ''}</span>
                                                                {touched.numerolote && errors.numerolote && <div className="text-danger">{errors.numerolote}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                            <div className="form-floating mb-3">
                                                                <input type="text" className={`form-control ${fc_34Map.kgagavecheck !== undefined ? (
                                                                    fc_34Map?.kgagavecheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    id="" placeholder='kg de agave'
                                                                    name="kgagave"
                                                                    value={values.kgagave}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur} />
                                                                <label htmlFor='floatingInput'>Kg de agave</label>
                                                                <span className='text-danger'>{fc_34Map?.kgagavecheck ? fc_34Map?.kgagave : ''}</span>
                                                                {touched.kgagave && errors.kgagave && <div className="text-danger">{errors.kgagave}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                            <div className="form-floating mb-3">
                                                                <input type="date" className={`form-control ${fc_34Map.fechamuestreocheck !== undefined ? (
                                                                    fc_34Map?.fechamuestreocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    id="" placeholder='Fecha muestreo' min={fechaHoy}
                                                                    name="fechamuestreo"
                                                                    value={values.fechamuestreo}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur} />
                                                                <label htmlFor='floatingInput'>Fecha de muestreo</label>
                                                                <span className='text-danger'>{fc_34Map?.fechamuestreocheck ? fc_34Map?.fechamuestreo : ''}</span>
                                                                {touched.fechamuestreo && errors.fechamuestreo && <div className="text-danger">{errors.fechamuestreo}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2'>
                                                            <div className="form-floating mb-3">
                                                                <textarea type="textarea" rows='5' className={`form-control ${fc_34Map.informacionadicionalcheck !== undefined ? (
                                                                    fc_34Map?.informacionadicionalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    id="" placeholder='Información adicional de la actividad'
                                                                    name="informacionadicional"
                                                                    value={values.informacionadicional}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <label htmlFor='floatingInput'>Información adicional sobre la actividad</label>
                                                                <span className='text-danger'>{fc_34Map?.informacionadicionalcheck ? fc_34Map?.informacionadicional : ''}</span>
                                                                {touched.informacionadicional && errors.informacionadicional && <div className="text-danger">{errors.informacionadicional}</div>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Fragment>
                                            }
                                        </div>
                                        <br />
                                    </div> <br />
                                    <div className='row'>
                                        <h4 className={`text-center ${estilos.labelNaranja}`}>INFORMACIÓN DEL SOLICITANTE</h4>
                                    </div>
                                    <div className='row justify-content-start'>
                                        <div className='col-xs-12 col-sm-12 col-md-12 col-xl-12 col-xxl-12'>
                                            <div className="form-floating mb-3">
                                                <select className={`form-select ${fc_34Map.tipoinstalacioncheck !== undefined ? (
                                                    fc_34Map?.tipoinstalacioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    name="especificaraduana"
                                                    value={values.tipoinstalacion}
                                                    onChange={e => {
                                                        const result = setDatos(e.target.value)
                                                        const { ...newValues } = values
                                                        //const cortar = e.target.value.split('/')
                                                        newValues.tipoinstalacion = e.target.value
                                                        if (result !== '') {
                                                            newValues.responsableinstalaciones = result.responsableinstalaciones
                                                            newValues.correoelectronico = result.correoelectronico
                                                            newValues.telefono = result.telefono
                                                            newValues.domicilio = result.domicilio
                                                        }
                                                        setValues(newValues)
                                                    }}
                                                    onBlur={handleBlur} >
                                                    <option value="0" >Tipo de instalacion</option>
                                                    {instalaciones?.map((opcion, index) => (
                                                        <option value={`${opcion.idtipoanexo === 1 ? opcion.idtipoanexo + '/' + opcion.idanexocliente : opcion.idtipoanexo === 2 ? opcion.idtipoanexo + '/' + opcion.idanexocliente : opcion.idtipoanexo === 3 ? opcion.idtipoanexo + '/' + opcion.idanexocliente : 'Domicilio Fiscal'}`} >
                                                            {`${opcion.idtipoanexo === 1 ? 'Unidad Producción: ' + opcion.informaciongeneralinstalacioncliente.alias : opcion.idtipoanexo === 2 ? 'Unidad Envasado: ' + opcion.informaciongeneralinstalacioncliente.alias : opcion.idtipoanexo === 3 ? 'Unidad Almacén: ' + opcion.informaciongeneralinstalacioncliente.alias : 'Domicilio Fiscal'}`}</option>
                                                    ))
                                                    }
                                                </select>
                                                <label htmlFor='floatingInput'></label>
                                                <span className='text-danger'>{fc_34Map?.tipoinstalacioncheck ? fc_34Map?.tipoinstalacion : ''}</span>
                                                {touched.tipoinstalacion && errors.tipoinstalacion && <div className="text-danger">{errors.tipoinstalacion}</div>}
                                            </div>
                                        </div>
                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                            <div className="form-floating mb-3">
                                                <input type="text" className={`form-control ${fc_34Map.responsableinstalacionescheck !== undefined ? (
                                                    fc_34Map?.responsableinstalacionescheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    id="" placeholder='responsable'
                                                    name="responsableinstalaciones"
                                                    value={values.responsableinstalaciones}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                <label htmlFor='floatingInput'>Nombre de responsable</label>
                                                <span className='text-danger'>{fc_34Map?.responsableinstalacionescheck ? fc_34Map?.responsableinstalaciones : ''}</span>
                                                {touched.responsableinstalaciones && errors.responsableinstalaciones && <div className="text-danger">{errors.responsableinstalaciones}</div>}
                                            </div>
                                        </div>
                                        <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3'>
                                            <div className="form-floating mb-3">
                                                <input type="text" className={`form-control ${fc_34Map.correoelectronicocheck !== undefined ? (
                                                    fc_34Map?.correoelectronicocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    id="" placeholder='responsable'
                                                    name="correoelectronico"
                                                    value={values.correoelectronico}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                <label htmlFor='floatingInput'>Correo Electrónico</label>
                                                <span className='text-danger'>{fc_34Map?.correoelectronicocheck ? fc_34Map?.correoelectronico : ''}</span>
                                                {touched.correoelectronico && errors.correoelectronico && <div className="text-danger">{errors.correoelectronico}</div>}
                                            </div>
                                        </div>
                                        <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3'>
                                            <div className="form-floating mb-3">
                                                <input type="number" className={`form-control ${fc_34Map.telefonocheck !== undefined ? (
                                                    fc_34Map?.telefonocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    id="" placeholder='telefono'
                                                    name="telefono"
                                                    value={values.telefono}
                                                    onChange={e => {
                                                        const { ...newValues } = values
                                                        newValues.telefono = e.target.value
                                                        setValues(newValues)
                                                    }}
                                                    onBlur={handleBlur}
                                                    onWheel={event => event.currentTarget.blur()}
                                                />
                                                <label htmlFor='floatingInput'>Teléfono</label>
                                                <span className='text-danger'>{fc_34Map?.telefonocheck ? fc_34Map?.telefono : ''}</span>
                                                {touched.telefono && errors.telefono && <div className="text-danger">{errors.telefono}</div>}
                                            </div>
                                        </div>
                                        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                            <div className="form-floating mb-3">
                                                <input type="text" className={`form-control ${fc_34Map.domiciliocheck !== undefined ? (
                                                    fc_34Map?.domiciliocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    id="" placeholder='domicilio'
                                                    name="domicilio"
                                                    value={values.domicilio}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                <label htmlFor='floatingInput'>Domicilio completo</label>
                                                <span className='text-danger'>{fc_34Map?.domiciliocheck ? fc_34Map?.domicilio : ''}</span>
                                                {touched.domicilio && errors.domicilio && <div className="text-danger">{errors.domicilio}</div>}
                                            </div>
                                        </div>
                                    </div>

                                </Fragment>
                                : <Fragment>
                                    <div className=" text-align: justify">
                                        <TerminosYCondicionesComponent terminosYCondiciones={terminosYCondiciones} formato={'fc_34'} />
                                    </div>
                                    <br />
                                    <br />
                                    {!modoCorreccion ?
                                        <div>
                                            <div className="row mt-4">
                                                {
                                                    modoEdicionBorrador ? (
                                                        <div className="d-grid gap-2 col-2 mx-auto">
                                                            <button type="submit"
                                                                onClick={() => { botonEnviarSolicitudBorradorFC_34(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                disabled={!terminosYCondiciones}>Enviar borrador</button>
                                                        </div>
                                                    ) : (
                                                        <div className="d-grid gap-2 col-2 mx-auto">
                                                            <button type="submit"
                                                                onClick={() => { botonEnviarSolicitudFC_34(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                disabled={!terminosYCondiciones}>Enviar</button>
                                                        </div>
                                                    )
                                                }

                                            </div>
                                        </div>
                                        :
                                        <div className="row mt-4">
                                            <div className="d-grid gap-2 col-2 mx-auto">
                                                <button type="submit"
                                                    onClick={() => { botonEnviarCorreccionesFC_34(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                    className={`btn ${estilos.botonNaranjaRedondo}`} disabled={!terminosYCondiciones}>Enviar correcciones</button>
                                            </div>
                                        </div>
                                    }
                                </Fragment>
                            }<br />
                            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
                            <BotonAtrasSiguienteComponent botonSiguiente={paginaSiguiente} botonAnterior={paginaAnterior} paginaActiva={paginaActiva} totalDePaginas={paginas.length} valores={values} />
                            {modalComponent()}
                            {envioCorrecto && <ModalEnviadoCorrectamente folioSolicitud={folio}></ModalEnviadoCorrectamente>}
                        </div >
                    </form>
                )}
            </Formik>
        </Fragment >
    )
}
export default withRouter(FormularioFC34BeneficiarioComponent)
